import { render, staticRenderFns } from "./StatusLabel.vue?vue&type=template&id=0421748a&"
import script from "./StatusLabel.vue?vue&type=script&lang=js&"
export * from "./StatusLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "StatusLabel.vue"
export default component.exports